/* eslint-disable */
/* スマホ・タブレット利用制限処理 */
$(document).ready( function(){
	// ページ読み込み時に実行したい処理
  // Ajax通信を開始
  if(window.getUtilizationTimeInfo === undefined) {
    return;
  }
  $.ajax({
		url: window.getUtilizationTimeInfo,
		type: 'GET',
		dataType: 'json',
		// フォーム要素の内容をハッシュ形式に変換
		//data: $('form').serializeArray(),
		//timeout: 5000,
		success: function(data){
		  // 通信成功時の処理を記述
		  console.log('success');
		  if (data.result) {
			  if(data.logout){
				window.location = data.logout_url; 
			  };
		  }else{
			alert("利用権限情報の取得に失敗しました。");
		  };
		  
		},
		error: function(){
		  // 通信失敗時の処理を記述
		  alert("利用権限情報の取得に失敗しました。");
		}
  })

});



// WEBPACK FOOTER //
// ./es6/user-common-js/legacy/utilizationtimeInfo.js